
let translationCache = {}
const COUNTRIES = ['de', 'fr', 'ch', 'uk', 'gb']
const DEFAULT_LANGUAGE = 'de'
const DISALLOWED_LANGUAGES = ['en']
const COUNTRIES_ALLOWED_TO_CHANGE_LANGUAGE = ['ch']

export const getCountryFromUrl = (path) => {
  return path.split("/").find(element => COUNTRIES.includes(element))
}

// Helper function to get effective language from URL parameters
const getCustomLanguage = (defaultLanguage, country = null) => {
  const fullPath = window.location.pathname;
  country = country || getCountryFromUrl(fullPath);

  if (!country || !COUNTRIES_ALLOWED_TO_CHANGE_LANGUAGE.includes(country.toLowerCase())) {
    return defaultLanguage;
  }

  const customLanguage = window.eventsTracking.getData('language');
  return customLanguage || defaultLanguage;
};


/**
/**
 * Translate a string by language and category
 * @important: Checking for french in CH is done inside this function by getCustomLanguage,
 *             just pass the language, no need to handle it yourself.
 */
export function translate (language, category, path){
  try {
    if (language?.toUpperCase() === 'CH') {
      window.clientLogger.error("language is CH", { translationPath: path });
    }
    
    // Get custom language if exists
    language = getCustomLanguage(language);
    if (!translationCache[language]){
      translationCache[language] = {}
    }

    if (!translationCache[language][category]){
      try {
        translationCache[language][category] = require(`../../resources/translations/${language}/${category}/translations.json`)
      } catch (err) {
        translationCache[language][category] = require(`../../resources/translations/${DEFAULT_LANGUAGE}/${category}/translations.json`)
      }

    }

    let paths = path.split("/")

    let currJson = translationCache[language][category]

    paths.forEach(currKey =>{currJson = currJson[currKey]} )

    return currJson
  } catch (err) {
    if (DISALLOWED_LANGUAGES.includes(language)) {
      window.clientLogger.warn("error in translator", err, {language, category, translationPath: path});
    } else {
      window.clientLogger.error("error in translator", err, {language, category, translationPath: path});
    }
    return null;
  }

    
}


export const getLocaleByCountry = (country) => {
  let language = "de";
  let countryCode = country?.toUpperCase();
  switch (country?.toLowerCase()){
    case "ch":
    case "ch-de":
      language = window.eventsTracking.getData('language') || "de";
      countryCode = "CH";
      break;
    case "ch-fr":
      language = "fr";
      countryCode = "CH";
      break;
    case "de":
      language = "de";
      break;
    case "fr":
      language = "fr";
      break;
    case "uk":
    case "gb":

      language = "en";
      countryCode = "GB";
      break;
    default:
      language = "de"
  }
  
  return language + "-" + countryCode;
}


export const getLanguageByCountry = (country)=>{
  switch (country?.toLowerCase()){
    case "ch":
      return window.eventsTracking.getData('language') || "de";
    case "ch-de":
      return "de";
    case "ch-fr":
      return "fr";
    case "de":
      return "de";
    case "fr":
      return "fr";
    case "uk":
    case "gb":

      return "en";
    default:
      return "de"
  }
}

export const getCurrencyByCountry = (country, shouldReturnSymbol = true) => {
  // Convert country to lowercase for consistent comparison
  const countryLowerCase = country?.toLowerCase();
  

  switch (countryLowerCase) {
    case "de":
    case "fr":
      return shouldReturnSymbol ? "€" : "EUR";

    case "gb":
    case "uk":
    case "en":
      return shouldReturnSymbol ? "£" : "GBP";

    case "ch":
      return shouldReturnSymbol ? "CHF" : "CHF";

    default:
      return shouldReturnSymbol ? "$" : "USD";
  }
};


export const getCurrencyByLocale = (locale, shouldReturnSymbol = true) => {
  const country = locale.split("-")[1];
  const countryLowerCase = country?.toLowerCase();

  switch (countryLowerCase) {
    case "de":
    case "fr":
      return shouldReturnSymbol ? "€" : "EUR";

    case "gb":
    case "uk":
    case "en":
      return shouldReturnSymbol ? "£" : "GBP";

    case "ch":
      return shouldReturnSymbol ? "₣" : "CHF";

    default:
      return shouldReturnSymbol ? "$" : "USD";
  }
};

export const getPrice = (price, locale = "de-DE", currencyRate = 1) => {
  if (locale === "fr-CH") {
    locale = "de-CH";
  }
  
  const options = {
    style: "currency",
    currency : getCurrencyByLocale(locale, false), // Get the three-letter currency code (not the symbol) for formatting
  };

  const formattedPrice = new Intl.NumberFormat(locale, options).format(Math.abs(price) * currencyRate);

  if (price < 0) { //Apperantly some formats do not support negative values, therefore using this small check
    return `- ${formattedPrice}`;
  }
  return formattedPrice
};



export const getCMSUrlPrefixByLocale = (locale) => {
  switch (locale.toLowerCase()) {
    case "de-de":
      return "de";
    case "fr-fr":
      return "fr";
    case "de-ch":
      return "ch-de";
    case "fr-ch":
      return "ch-fr";
    case "en-uk":
    case "en-gb":
      return "uk";
    default:
      return "de";
  }
}


